import "./loading.css";

export const Loading = () => {
  return <span className="loader"></span>;
};
